import { API_URL } from './Config';
import { startLoading, endLoading, SnackBar, handleHTTPError, ShowLoadingSpinner } from './CommonActions';
import store from '../store';
import axios from 'axios';

export function storeAboutUsDetails(list) {
    return {
        type: 'STORE_ABOUT_US_DETAILS',
        list: list.data
    }
}

export function getAboutUs() {
    return function (dispatch) {
        dispatch(startLoading());
        fetch(API_URL + '/api/about_us/get', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        }).then(handleHTTPError)
            .then((response) => {
                dispatch(endLoading());
                response.json().then((json) => {
                    dispatch(endLoading());
                    dispatch(storeAboutUsDetails(json));
                });
            }).catch((error) => {
                dispatch(endLoading());
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}


export function countact_mail(data) {
    return function (dispatch) {
        dispatch(startLoading());
        fetch(API_URL + '/api/contact/mail', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            },
            body: JSON.stringify(data)
        }).then(handleHTTPError)
            .then((response) => {
                dispatch(endLoading());
                response.json().then((json) => {
                    dispatch(endLoading());
                    if(json.success) {
                        dispatch(SnackBar(true, json.message, 'succuss'));
                    }
                });
            }).catch((error) => {
                dispatch(endLoading());
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}